import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { Colors, Sizes } from '@/components/ui/types';
import Fieldset from '../fieldset';
import { FileInputProps, FileInputVariant } from './types';

const sizeClasses: Record<Sizes, string> = {
  xs: 'file-input-xs',
  sm: 'file-input-sm',
  md: 'file-input-md',
  lg: 'file-input-lg',
  xl: 'file-input-xl',
};

const colorClasses: Record<Colors, string> = {
  default: '',
  neutral: 'file-input-neutral',
  primary: 'file-input-primary',
  secondary: 'file-input-secondary',
  accent: 'file-input-accent',
  info: 'file-input-info',
  success: 'file-input-success',
  warning: 'file-input-warning',
  error: 'file-input-error',
};

const variantClasses: Record<FileInputVariant, string> = {
  default: '',
  ghost: 'file-input-ghost',
};

const FileInputBase = forwardRef<HTMLInputElement, FileInputProps>(
  (
    {
      className,
      size = 'md',
      color = 'default',
      variant = 'default',
      error = false,
      ...props
    },
    ref,
  ) => {
    const classes = twMerge(
      'file-input',
      sizeClasses[size],
      colorClasses[color],
      variantClasses[variant],
      error && 'file-input-error',
      className,
    );

    return <input ref={ref} type="file" className={classes} {...props} />;
  },
);

FileInputBase.displayName = 'FileInput';

export const FileInput = Object.assign(FileInputBase, {
  Fieldset,
});
